import { storableError } from './errors';

export const GATE_STATUS = {
  OK: 'ok',
  HOLD: 'hold',
  BLOCKED: 'blocked',
  NEEDS_BILLING: 'needs-billing',
  PROVIDER_INCOMPLETE: 'provider-incomplete',
};

// A privileged endpoint answers a VAT gate with 409 { code, reason }. The
// generic api.post throws before reading the body, so read it here and
// carry the code on the storable error.
export const withGateCode = e => {
  const res = e && e.apiResponse;
  if (!res || res.status !== 409 || typeof res.json !== 'function') {
    return Promise.resolve(storableError(e));
  }
  return res
    .json()
    .then(body => ({ ...storableError(e), code: body.code, reason: body.reason }))
    .catch(() => storableError(e));
};

export const gateStatusFromError = err => {
  const code = err && err.code;
  if (!code) return null;
  if (code === 'hold') return GATE_STATUS.HOLD;
  if (code.startsWith('blocked:')) return GATE_STATUS.BLOCKED;
  if (code === 'buyer-billing-missing') return GATE_STATUS.NEEDS_BILLING;
  if (code === 'seller-declaration-missing') return GATE_STATUS.PROVIDER_INCOMPLETE;
  return null;
};
